import { Lightbox } from "../../classes/Lightbox";
const initApartmentCard = () => {
	const sections = document.querySelectorAll("section.apartment-card");

	if (sections.length) {
		Array.from(sections).forEach((section) => {
			const currentApartmentId = section.getAttribute("data-apartment-id");
			const slider = section.querySelector(".mySwiper-card");
			const sliderButtons = JSON.parse(section.getAttribute("data-buttons"));
			const showRange = section.querySelector(".plan header button");
			const range = section.querySelector(".range");
			const compass = section.querySelector(".plan header > svg");
			const rangeSun = section.querySelector("svg.big-sun");
			const alwaysShowSun = slider.classList.contains("with-sun");

			new Swiper(slider, {
				slidesPerView: 1,
				spaceBetween: 50,
				loop: true,
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
					renderBullet: function (index, className) {
						return sliderButtons
							? '<li class="' +
									className +
									'">' +
									sliderButtons[index] +
									"</li>"
							: '<li class="' + className + '">' + (index + 1) + "</li>";
					},
				},
				on: {
					slideChange: function (swiper) {
						if (swiper.realIndex === 2 || alwaysShowSun) {
							showRange.style.visibility = "visible";
							compass.style.visibility = "visible";
						} else {
							showRange.style.visibility = "hidden";
							compass.style.visibility = "hidden";
							showRange.classList.remove("active");
							rangeSun.classList.remove("active");
							range.classList.remove("active");
							showRange.querySelector("span").innerText = "Теневая карта";
						}
					},
				},
			});

			const group = document.querySelector(
				`g[data-id="${currentApartmentId}"]`
			);
			if (group) {
				const paths = group.querySelectorAll("path");
				paths.forEach((path) => {
					path.setAttribute("style", "fill: #e3ef9c;");
				});
			}

			const changePriceButtons = section.querySelectorAll(
				".price-buttons button"
			);
			const price = section.querySelector("span.price");
			const leadButton = section.querySelector("aside > button");

			const currentTime = new Date().toLocaleString("ru-RU", {
				timeZone: "Asia/Bangkok",
				hour: "numeric",
			});

			leadButton.addEventListener("click", () => {
				fetch("/ajax/?action=get-leadform", {
					method: "POST",
					credentials: "same-origin",
					headers: {
						"X-Requested-With": "XMLHttpRequest",
						"Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
					},
				})
					.then(function (data) {
						if (!data.ok) {
							throw new Error("Could not fetch, status: " + data.status);
						}

						return data.json();
					})
					.then(function (response) {
						Lightbox.open(response.rendered, null, "lead-lightbox");
					});
			});

			for (let priceButton of changePriceButtons) {
				priceButton.addEventListener("click", () => {
					changePriceButtons.forEach((item) => item.classList.remove("active"));
					priceButton.classList.add("active");
					price.innerHTML =
						priceButton.getAttribute("data-price") +
						"&thinsp;" +
						priceButton.innerText;
				});
			}
		});
	}
};

export { initApartmentCard };
